<div class="main-toolbar-m">
  <img style="max-width: 63px;max-height: 32px;" mat-card-image src="./assets/icons/logo-fiserv.svg" alt="logo fiserv">
</div>

<app-page-error title="{{'PAGE_NOT_FOUND' | translate}}">
  <p>{{"PAGE_SEARCH_NOT_EXIST" | translate}}</p>
  <p>{{"ADDRESS_TYPING_NOT_FOUND" | translate}}</p>
</app-page-error>
